/**
 * Dashboard copy — English / Arabic. Extend per-page locale files later.
 */

function resolve(obj, path) {
  const parts = path.split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

const dashboardStrings = {
  en: {
    kpi: {
      totalOrders: 'Total Orders',
      totalClients: 'Total Clients',
      monthlyOrders: 'Monthly Orders',
      todaysOrders: "Today's Orders",
      pendingOrders: 'Pending Orders',
      completedToday: 'Completed Today',
    },
    deliveryStatus: {
      title: 'Delivery Status',
      subtitle: "Today's orders",
      centerLabel: 'Today',
      enlarge: 'Enlarge Delivery Status chart',
      loading: 'Loading status…',
      deliveryInProgress: 'Delivery in progress',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      returned: 'Returned',
      picked: 'Picked',
      pickupInProgress: 'Pickup in progress',
      pickupReturn: 'Pickup return',
      pickupCancelled: 'Pickup cancelled',
    },
    topClients: {
      title: 'Top Clients (Monthly)',
      subtitle: 'Order count · top 10',
      enlarge: 'Enlarge Top Clients chart',
      ordersAxis: 'Orders',
      loading: 'Loading clients…',
      empty: 'No client orders this month',
    },
    monthlyOrders: {
      title: 'Monthly Orders',
      subtitle: 'Order intensity by area · current month',
      enlarge: 'Enlarge Monthly Orders map',
    },
    map: {
      thisMonth: 'this month',
      dubai: 'Dubai',
      dubaiSouth: 'Dubai (south)',
      abuDhabi: 'Abu Dhabi',
      abuDhabiEast: 'Abu Dhabi (east)',
      sharjah: 'Sharjah',
      ajman: 'Ajman',
      alAin: 'Al Ain',
      fujairah: 'Fujairah',
      rak: 'Ras Al Khaimah',
      uaq: 'Umm Al Quwain',
      western: 'Western Region',
      ordersCount: '{n} orders',
    },
    topAreas: {
      title: 'Top Delivery Areas',
      subtitle: 'Order count · top 10',
      loading: 'Loading areas…',
      empty: 'No delivery areas found',
      ordersAxis: 'Orders',
    },
    areas: {
      dubaiMarina: 'Dubai Marina',
      downtown: 'Downtown Dubai',
      jbr: 'JBR',
      businessBay: 'Business Bay',
      palm: 'Palm Jumeirah',
    },
    recentOrders: {
      title: 'Recent Orders',
      loading: 'Loading orders…',
      empty: 'No recent orders',
      justNow: 'Just now',
      minutesAgo: '{n} min ago',
      hoursAgo: '{n} hr ago',
      daysAgo: '{n} day ago',
    },
    drivers: {
      title: 'Drivers Summary',
      subtitle: "Today's deliveries",
      loading: 'Loading drivers…',
      empty: 'No driver deliveries today',
      deliveries: 'deliveries',
    },
    modal: {
      closeOverlay: 'Close enlarged chart',
      close: 'Close',
    },
    enlarged: {
      delivery: 'Delivery Status',
      clients: 'Top Clients (Monthly)',
      orders: 'Monthly Orders',
    },
    moreOptions: 'More options',
  },
  ar: {
    kpi: {
      totalOrders: 'إجمالي الطلبات',
      totalClients: 'إجمالي العملاء',
      monthlyOrders: 'طلبات الشهر',
      todaysOrders: 'طلبات اليوم',
      pendingOrders: 'طلبات معلقة',
      completedToday: 'مكتمل اليوم',
    },
    deliveryStatus: {
      title: 'حالة التسليم',
      subtitle: 'طلبات اليوم',
      centerLabel: 'اليوم',
      enlarge: 'تكبير مخطط حالة التسليم',
      loading: 'جاري تحميل الحالة…',
      deliveryInProgress: 'التسليم قيد التنفيذ',
      delivered: 'تم التسليم',
      cancelled: 'ملغى',
      returned: 'مرتجع',
      picked: 'تم الاستلام',
      pickupInProgress: 'الاستلام قيد التنفيذ',
      pickupReturn: 'إرجاع الاستلام',
      pickupCancelled: 'إلغاء الاستلام',
    },
    topClients: {
      title: 'أفضل العملاء (شهريًا)',
      subtitle: 'عدد الطلبات · أعلى 10',
      enlarge: 'تكبير مخطط أفضل العملاء',
      ordersAxis: 'طلبات',
      loading: 'جاري تحميل العملاء…',
      empty: 'لا توجد طلبات للعملاء هذا الشهر',
    },
    monthlyOrders: {
      title: 'الطلبات الشهرية',
      subtitle: 'كثافة الطلبات حسب المنطقة · الشهر الحالي',
      enlarge: 'تكبير خريطة الطلبات الشهرية',
    },
    map: {
      thisMonth: 'هذا الشهر',
      dubai: 'دبي',
      dubaiSouth: 'دبي (جنوب)',
      abuDhabi: 'أبوظبي',
      abuDhabiEast: 'أبوظبي (شرق)',
      sharjah: 'الشارقة',
      ajman: 'عجمان',
      alAin: 'العين',
      fujairah: 'الفجيرة',
      rak: 'رأس الخيمة',
      uaq: 'أم القيوين',
      western: 'المنطقة الغربية',
      ordersCount: '{n} طلبًا',
    },
    topAreas: {
      title: 'أفضل مناطق التسليم',
      subtitle: 'عدد الطلبات · أعلى 10',
      loading: 'جاري تحميل المناطق…',
      empty: 'لا توجد مناطق تسليم',
      ordersAxis: 'طلبات',
    },
    areas: {
      dubaiMarina: 'دبي مارينا',
      downtown: 'وسط مدينة دبي',
      jbr: 'جميرا بيتش',
      businessBay: 'الخليج التجاري',
      palm: 'نخلة جميرا',
    },
    recentOrders: {
      title: 'الطلبات الأخيرة',
      loading: 'جاري تحميل الطلبات…',
      empty: 'لا توجد طلبات حديثة',
      justNow: 'الآن',
      minutesAgo: 'منذ {n} د',
      hoursAgo: 'منذ {n} س',
      daysAgo: 'منذ {n} يوم',
    },
    drivers: {
      title: 'ملخص السائقين',
      subtitle: 'تسليمات اليوم',
      loading: 'جاري تحميل السائقين…',
      empty: 'لا توجد تسليمات للسائقين اليوم',
      deliveries: 'تسليمات',
    },
    modal: {
      closeOverlay: 'إغلاق المخطط المكبر',
      close: 'إغلاق',
    },
    enlarged: {
      delivery: 'حالة التسليم',
      clients: 'أفضل العملاء (شهريًا)',
      orders: 'الطلبات الشهرية',
    },
    moreOptions: 'مزيد من الخيارات',
  },
};

export function getDashboardT(lang) {
  const root = dashboardStrings[lang] || dashboardStrings.en;
  return (path, vars) => {
    let v = resolve(root, path);
    if (typeof v !== 'string') return path;
    if (vars && typeof vars === 'object') {
      Object.keys(vars).forEach((k) => {
        v = v.replace(new RegExp(`\\{${k}\\}`, 'g'), String(vars[k]));
      });
    }
    return v;
  };
}
